export const CLOUDINARY_PATH = 'https://res.cloudinary.com/adrianparr/image/upload/f_auto/v1594030165/tjbuckfield/'
export const CLOUDINARY_PATH_THUMBNAIL = 'https://res.cloudinary.com/adrianparr/image/upload/c_thumb,w_92,g_face,f_auto/v1594034102/tjbuckfield/'
